import { ExerciseMapType, ExerciseType } from 'types/exercise';

export const createExercisesMap = (exercises: ExerciseType[]): ExerciseMapType => {
    return exercises.reduce((acc, exercise) => {
        acc[exercise.id] = exercise;

        return acc;
    }, {} as ExerciseMapType);
};
